<template>
  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
        <h1>莎士比耶写作助手</h1>
      </div>

      <el-form ref="formRef" :model="loginForm" :rules="rules" label-position="top" @submit.prevent="handleLogin"
        class="login-form">
        <el-form-item label="账号" prop="username">
          <el-input v-model="loginForm.username" placeholder="请输入账号" clearable />
        </el-form-item>

        <el-form-item label="密码" prop="password">
          <el-input v-model="loginForm.password" type="password" show-password placeholder="请输入密码" />
        </el-form-item>

        <!-- 移除“记住我” -->

        <el-form-item>
          <el-button type="primary" :loading="isLoading" class="login-btn" size="large" @click="handleLogin">
            登录
          </el-button>
        </el-form-item>

        <!-- 移除内联错误提示，统一用 ElMessage -->
      </el-form>

      <div class="login-footer">
        <p>还没有账户？<a href="#" @click.prevent="registerDialogVisible = true">立即注册</a></p>
      </div>

      <el-dialog v-model="registerDialogVisible" width="400px" class="register-dialog" :append-to-body="true"
        :lock-scroll="true" :align-center="true">
        <div class="register-dialog-content">
          <div class="register-text">请添加客服注册账号并充值余额</div>
          <img :src="kefuImg" alt="客服" class="register-kefu-img" />
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { loginApi } from '@/api/auth'

const router = useRouter()

// 表单数据
const loginForm = reactive({
  username: '',
  password: ''
})

// 表单引用与校验规则（Element Plus）
const formRef = ref()
const rules = {
  username: [
    { required: true, message: '请输入账号', trigger: 'blur' },
    { min: 3, message: '账号长度至少3位', trigger: 'blur' },
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' },
    { min: 6, message: '密码长度至少6位', trigger: 'blur' },
  ],
}

// 状态管理
const isLoading = ref(false)
const registerDialogVisible = ref(false)
import kefuImg from '../image/kefu.jpg'

// 登录处理
const handleLogin = async () => {
  // 先进行表单校验
  const valid = await formRef.value?.validate().catch(() => false)
  if (!valid) return

  isLoading.value = true

  try {
    // 调用登录接口，注意参数名为 userName 和 passWord
    const userData = await loginApi({
      userName: loginForm.username,
      passWord: loginForm.password
    })

    // 登录成功，保存用户信息到本地缓存
    const userInfo = {
      id: userData.id,
      username: userData.account_number,
      balance_cny: userData.balance_cny,
      token: userData.token,
      loginTime: new Date().toISOString()
    }

    // 保存到localStorage
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
    localStorage.setItem('token', userData.token)

    ElMessage.success('登录成功')
    
    // 跳转到创作页面
    router.push('/')
    
  } catch (error) {
    // 错误信息已在 request.js 的响应拦截器中处理
    console.error('登录失败:', error)
  } finally {
    isLoading.value = false
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.login-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  padding: 40px;
  width: 100%;
  max-width: 400px;
  animation: slideUp 0.6s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-header h1 {
  color: #333;
  font-size: 28px;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.login-header p {
  color: #666;
  font-size: 14px;
  margin: 0;
}

.login-form {
  margin-bottom: 20px;
}

/* 优化登录按钮视觉样式 */
.login-btn {
  width: 100%;
  height: 48px;
  /* 统一较高的点击面积 */
  font-size: 16px;
  font-weight: 600;
  border-radius: 10px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  border: none;
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.35);
  transition: transform 0.15s ease, box-shadow 0.2s ease, background 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.login-btn:hover:not(.is-disabled) {
  transform: translateY(-1px);
  box-shadow: 0 12px 28px rgba(102, 126, 234, 0.4);
}

.login-btn:active:not(.is-disabled) {
  transform: translateY(0);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.35);
}

.login-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.25), 0 8px 20px rgba(102, 126, 234, 0.35);
}

.login-btn.is-disabled,
.login-btn.is-loading {
  opacity: 0.85;
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.28);
}

.login-footer {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.login-footer p {
  color: #666;
  font-size: 14px;
  margin: 0;
}

.login-footer a {
  color: #667eea;
  text-decoration: none;
  font-weight: 500;
}

.login-footer a:hover {
  text-decoration: underline;
}

@media (max-width: 480px) {
  .login-card {
    padding: 30px 20px;
    margin: 10px;
  }

  .login-header h1 {
    font-size: 24px;
  }
}

.register-dialog :deep(.el-dialog__body) {
  padding: 40px;
}

.register-dialog-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
}

.register-text {
  font-size: 14px;
  color: #333;
  text-align: center;
}

.register-kefu-img {
  width: 100%;
  height: auto;
  border-radius: 8px;
}
</style>
